import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { UserService } from './services/user.service';

@Injectable()
export class PropertiesGuardService {
  constructor(
    private authService: AuthService,
    private userService: UserService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    avoidRedirect: boolean = false
  ): Observable<boolean> {
    return this.authService.canActivateProtectedRoutes$.pipe(
      switchMap(isAuthenticated => {
        if (!isAuthenticated) {
          if (!avoidRedirect) {
            if (localStorage.getItem('autoLogout') === 'true') {
              localStorage.removeItem('autoLogout');
              this.router.navigate(['/landing']);
            } else {
              this.router.navigateByUrl('/landing/true');
            }
          }
          return of(false);
        }

        return this.userService.getUserInfo().pipe(
          take(1),
          map(user => {
            if (!user) {
              if (!avoidRedirect) {
                this.router.navigate(['/onboarding']);
              }
              return false;
            }

            const hasPropertiesSubscription = user.subscriptionsHistory
              ?.filter(x => x.isActive)
              .some(subscription => {
                return subscription.stripePriceId === environment.subscriptionProducts.properties;
              });

            if (!hasPropertiesSubscription) {
              if (!avoidRedirect) {
                this.router.navigate(['/']);
              }
              return false;
            }

            return true;
          })
        );
      })
    );
  }
}
